export const replaceThirdSlash = (string: string) => {
  let count = 0
  return string.replace(/\//g, (match: string) => {
    count++
    if (count === 3) {
      return '#/'
    }
    return match
  })
}
